import React from "react";
import { SEO, MainLayout, ProfileApproved } from "../../../../components";

const ProfileApprovedPage = () => {
  return (
    <>
      <SEO title="profile approved" />
      <MainLayout>
        <ProfileApproved />
      </MainLayout>
    </>
  );
};

export default ProfileApprovedPage;
